import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { MapComponent } from '../map/map.component';

@Component({
  selector: 'app-map-modal',
  templateUrl: './map-modal.component.html',
  styleUrls: ['./map-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, MapComponent]
})
export class MapModalComponent implements OnInit {
  @Input() isWeb: boolean = false;
  @Input() userLocation?: { lat: number, lng: number } | null = null;
  @Input() showRangeSelector: boolean = false;
  @Input() initialRange: number = 0;

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {}

  // Método para cerrar el modal sin seleccionar ubicación
  cancel() {
    this.modalCtrl.dismiss(null, 'cancel');
  }

  // Método para recibir la ubicación seleccionada del mapa y cerrar el modal
  locationSelected(locationData: any) {
    // Asegurarnos de que incluimos el rango en los datos
    if (this.showRangeSelector && locationData.range === undefined) {
      locationData.range = this.initialRange;
    }
    this.modalCtrl.dismiss(locationData, 'confirm');
  }
}
